/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type MetricsMetadata = {
  /**
   * The granularity used for time bucketing, or null if none was specified.
   */
  granularity?: string | null | undefined;
  /**
   * Query execution time in milliseconds.
   */
  queryTimeMs?: number | undefined;
  /**
   * Number of data points returned.
   */
  rowCount?: number | undefined;
  /**
   * Maximum number of rows the query will return.
   */
  rowLimit?: number | undefined;
  /**
   * Whether the results were truncated due to hitting the row limit.
   */
  truncated?: boolean | undefined;
};

/** @internal */
export const MetricsMetadata$inboundSchema: z.ZodType<
  MetricsMetadata,
  z.ZodTypeDef,
  unknown
> = z.object({
  granularity: z.nullable(z.string()).optional(),
  query_time_ms: z.number().int().optional(),
  row_count: z.number().int().optional(),
  row_limit: z.number().int().optional(),
  truncated: z.boolean().optional(),
}).transform((v) => {
  return remap$(v, {
    "query_time_ms": "queryTimeMs",
    "row_count": "rowCount",
    "row_limit": "rowLimit",
  });
});
/** @internal */
export type MetricsMetadata$Outbound = {
  granularity?: string | null | undefined;
  query_time_ms?: number | undefined;
  row_count?: number | undefined;
  row_limit?: number | undefined;
  truncated?: boolean | undefined;
};

/** @internal */
export const MetricsMetadata$outboundSchema: z.ZodType<
  MetricsMetadata$Outbound,
  z.ZodTypeDef,
  MetricsMetadata
> = z.object({
  granularity: z.nullable(z.string()).optional(),
  queryTimeMs: z.number().int().optional(),
  rowCount: z.number().int().optional(),
  rowLimit: z.number().int().optional(),
  truncated: z.boolean().optional(),
}).transform((v) => {
  return remap$(v, {
    queryTimeMs: "query_time_ms",
    rowCount: "row_count",
    rowLimit: "row_limit",
  });
});

export function metricsMetadataToJSON(
  metricsMetadata: MetricsMetadata,
): string {
  return JSON.stringify(MetricsMetadata$outboundSchema.parse(metricsMetadata));
}
export function metricsMetadataFromJSON(
  jsonString: string,
): SafeParseResult<MetricsMetadata, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => MetricsMetadata$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'MetricsMetadata' from JSON`,
  );
}
